export const INSTANT_VALIDATION_BOUNDARY_NAME =
  '__next_instant_validation_boundary__'

export const INSTANT_SLOT_MARKER_PREFIX = '__next_instant_slot_'
export const INSTANT_SLOT_MARKER_SUFFIX = '__'
